class LocalizationForm extends HTMLElement {
    constructor() {
        super();
        this.form = this.querySelector('form');
        this.select = this.querySelector('.js-language-select');
        if (!this.form || !this.select) return;
        this.selectValueBeforeOpen = this.select.value;
        this.select2WasOpened = false;

        $(this.select).on('change', this.onChange.bind(this));
        $(this.select).on('select2:open', this.onSelect2Open.bind(this));
        $(this.select).on('select2:close', this.onSelect2Close.bind(this));
    }

    onChange() {
        const select2Instance = $(this.select).data('select2');
        if (select2Instance && select2Instance.isOpen()) {
            return;
        }
        this.form.submit();
    }

    onSelect2Open() {
        this.select2WasOpened = true;
        this.selectValueBeforeOpen = this.select.value;
    }

    onSelect2Close() {
        if (!this.select2WasOpened) return;
        this.select2WasOpened = false;
        if (this.select.value !== this.selectValueBeforeOpen) {
            this.form.submit();
        }
    }
}

customElements.define('localization-form', LocalizationForm);
